import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const IPad = () => {
  return (
    <div>
      <Navbar />
      IPad
      <Footer />

    </div>
  )
}

export default IPad
